// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3FvQd","left":"InfoRow_left__23k1I"};